import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'

import { createLink, updateLink } from '../../services/links'
import { Button } from '../Button'

interface IValue {
  value: { title: string; link: string }
  prioritize: string
  published: boolean
}

export const Prioritize: React.FC<IValue> = ({ value, prioritize, published }) => {
  const [activeBtn, setActiveBtn] = useState(prioritize ? prioritize : '')
  const [errors, setErrors] = useState<string>('')
  const { t } = useTranslation()
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const queryId = params.get('id')

  const firstRowButtons = [t('btnNon'), t('BUZZ'), t('WOBBLE'), t('POP'), t('SWIPE'), t('Flash')]

  const handleBtnClick = (name: string) => {
    setActiveBtn(name)
    handleSave()
  }

  const handleSave = () => {
    if (!value.title.trim() || !value.link.trim()) {
      setErrors(t('validation'))
      return
    }
    setErrors('')
    const data = {
      published: published,
      prioritize: activeBtn,
    }
    queryId ? updateLink(data, queryId) : createLink(data)
    toast.success(t('linkUpdateSuccess'))
  }

  return (
    <div>
      <p className="mt-5 font-bold">{t('prioritize')}</p>
      <p className="mb-2">{t('prioritizeDesc')}</p>
      <div className="mb-3 flex justify-start gap-2 flex-wrap">
        {firstRowButtons.map((label, index) => (
          <Button
            key={index}
            type="button"
            className={`${activeBtn === label ? 'border border-[#407BFF] text-[#407BFF]' : 'text-black'} w-full bg-white text-sm text-black hover:border hover:border-[#407BFF] hover:bg-white hover:text-[#407BFF] xl:w-[90px]`}
            text={label}
            onClick={() => handleBtnClick(label)}
          />
        ))}
      </div>
      <p className="mt-2 text-sm text-red-600">{errors}</p>
    </div>
  )
}
